// @flow
import $ from 'jquery';
import JQueryView from '../../common/JQueryView';
import { addCommas } from '../../../utils/commonUtils';

export default class ConfirmView extends JQueryView {
  constructor(paramsJson: string) {
    super('.simple_form');

    this.initSessionStorage(paramsJson);

    this.formatComma();

    // daterangepickerの背景色変更暫定措置
    $('.input-group-text').css('background-color', '#ECECEC');

    window.onsubmit = event => {
      this.onSubmit(event);
    };
  }

  initSessionStorage = (paramsJson: string) => {
    sessionStorage.setItem('checked_right_strikers', paramsJson);
  };

  formatComma = () => {
    $('input.comma-numeric').each((i, e) => {
      $(e).val(
        addCommas(
          $(e)
            .val()
            .replace(/[,.]/g, ''),
        ),
      );
    });
  };

  onSubmit(event: Event) {
    if (
      $(event.target).find('input[type="submit"][value="手続きを完了する"]')
        .length > 0
    ) {
      sessionStorage.removeItem('checked_right_strikers');
    }
    return true;
  }
}
